import * as React from 'react'

import { type NonFsdsTheme,resolveNonFsdsTheme } from '@/lib/non-fsds-theme'

import type { LandingInstructor } from '@/components/homepage/non-fsds-landing-content'
import NonFsdsInstructorCard from '@/components/homepage/non-fsds-sections/non-fsds-instructor-card'

interface NonFsdsLecturersSectionProps {
  title: string
  instructors: LandingInstructor[]
  isEnglish: boolean
  theme?: NonFsdsTheme | string
}

export default function NonFsdsLecturersSection({ title, instructors, isEnglish, theme = 'general' }: NonFsdsLecturersSectionProps) {
  const subtitle = isEnglish
    ? 'Breakthroughs happen faster when you learn with mentors and peers in one community.'
    : 'Bứt phá nhanh hơn khi học cùng mentor và cộng đồng cùng mục tiêu.'

  const themeStyles = {
    general: { sectionBg: 'from-blue-50/80 via-sky-50/40 to-blue-50/60', blob1: 'bg-blue-400/10', blob2: 'bg-sky-400/10' },
    'english-academy': { sectionBg: 'from-blue-50/60 via-emerald-50/40 to-blue-50/60', blob1: 'bg-blue-400/10', blob2: 'bg-emerald-400/10' },
    programming: { sectionBg: 'from-indigo-50/80 via-blue-50/40 to-indigo-50/60', blob1: 'bg-indigo-400/10', blob2: 'bg-blue-400/10' },
    math: { sectionBg: 'from-teal-50/80 via-sky-50/40 to-teal-50/60', blob1: 'bg-teal-400/10', blob2: 'bg-sky-400/10' },
  }[resolveNonFsdsTheme(theme)]

  return (
    <section
      data-testid="non-fsds-lecturers-section"
      className={`relative overflow-hidden bg-gradient-to-br px-4 py-16 sm:px-6 sm:py-20 lg:py-24 ${themeStyles.sectionBg}`}
    >
      {/* Decorative background blobs */}
      <div className={`pointer-events-none absolute -left-40 top-20 h-96 w-96 rounded-full blur-3xl ${themeStyles.blob1}`} />
      <div className={`pointer-events-none absolute -right-40 bottom-20 h-96 w-96 rounded-full blur-3xl ${themeStyles.blob2}`} />

      <div className="relative mx-auto max-w-7xl">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">{title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-slate-600">{subtitle}</p>
        </div>

        <div className="mt-12 grid auto-rows-fr grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {instructors.map(instructor => (
            <NonFsdsInstructorCard key={instructor.id} instructor={instructor} isEnglish={isEnglish} />
          ))}
        </div>
      </div>
    </section>
  )
}
